<template>
  <div class="fiches_medicales">
    <div id="head-page" class="books parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/livres-02.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.3"><img class="" src="@/assets/images/head/livres.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/papillon.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

   <div class="grid-container content-page fiches-medicales">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-12 large-7 cell">
          <title-page attrpage="Documents et ressources médicales" baseline="Vous trouverez ici de l’information médicale et des conseils pratiques.">La Bibliothèque</title-page>
          <p>Vous pouvez filtrer les contenus par format, en cliquant sur l’icône correspondante, et par thématique, en cliquant sur la catégorie en gris. </p>
        </div>
        <div class="small-12 medium-12 large-5 cell filtre-type">
          <span>Trier par : </span>
          <pastille type-item="tous" :active="category === ''" @click="e => selectCategory('')"></pastille>
          <pastille type-item="fiches" :active="category === 'fiche'" @click="e => selectCategory('fiche')"></pastille>
          <pastille type-item="article" :active="category === 'article'" @click="e => selectCategory('article')"></pastille>
          <pastille type-item="bd" :active="category === 'bd'" @click="e => selectCategory('bd')"></pastille>
          <pastille type-item="game" :active="category === 'game'" @click="e => selectCategory('game')"></pastille>
          <pastille type-item="video" :active="category === 'video'" @click="e => selectCategory('video')"></pastille>
        </div>
      </div>

      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-12 cell ">
          <form method="" class="formulaire search">
            <p>Filtres :</p>
            <!--
            <input type="text" name="search" id="search" placeholder="Taper votre recherche" />
            <input class="button btnPush" name="submit" type="submit" value="Ok" />
            -->
          </form>

          <ul class="list-filtre">
            <li :class="{ active: tag === 'leucemie' }" @click="e => selectTag('leucemie')">Leucémies - Informations Générales </li>
            <li :class="{ active: tag === 'chimio' }" @click="e => selectTag('chimio')">Chimiothérapie</li>
            <li :class="{ active: tag === 'examens' }" @click="e => selectTag('examens')">Examens</li>
            <li :class="{ active: tag === 'st' }" @click="e => selectTag('st')">Autres soins et traitements</li>
            <li :class="{ active: tag === 'hosto' }" @click="e => selectTag('hosto')">Hospitalisation</li>
            <li :class="{ active: tag === 'radio' }" @click="e => selectTag('radio')">Radiothérapie</li>
            <li :class="{ active: tag === 'greffe' }" @click="e => selectTag('greffe')">Greffe de moelle osseuse</li>
            <li :class="{ active: tag === 'essai' }" @click="e => selectTag('essai')">Recherche Clinique - Essais Thérapeutiques</li>
            <li :class="{ active: tag === 'home' }" @click="e => selectTag('home')">Retour à la maison & hygiène de vie</li>
            <li :class="{ active: tag === 'school' }" @click="e => selectTag('school')">Scolarité</li>
            <li :class="{ active: tag === 'social' }" @click="e => selectTag('social')">Accompagnement social</li>
          </ul>
        </div>
      </div>

      <div class="grid-x grid-margin-x">

        <div v-for="fiche in fiches" class="small-12 medium-6 large-4 cell">
          <item-fiche :lien="fiche.url || 'fiche_medicale'" :titlebox="fiche.title" :type-item="fiche.type">{{ fiche.content }}</item-fiche>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import ItemFiche from '@/components/ItemFiche'
  import Pastille from '@/components/Pastille'
  import TitlePage from '@/components/TitlePage'
  import FichesDB from '@/datas/fiches'

  export default {
    components: { Pastille, ItemFiche, TitlePage },
    async mounted () {
      this.fichesData = await FichesDB();

      if (this.currentUser && this.currentUser.account_type === 'child') {
        this.$store.dispatch('seenLibrary')
      }
    },
    computed: {
      fiches() {
        if (this.search === "" && this.category === "" && this.tag === "") {
          return this.fichesData
        }

        return this.fichesData.filter(fiche => {
          if(this.category && fiche.type !== this.category) return false
          if(this.tag && fiche.tags.indexOf(this.tag) === -1) return false

          return true
        })
      },
      currentUser() {
        return this.$store.state.me
      }
    },
    methods: {
      selectCategory(category) {
        this.category = category;
      },
      selectTag(tag) {
        if(this.tag === tag) this.tag = ""
        else this.tag = tag
      }
    },
    data() {
      return {
        search: "",
        category: "",
        tag: "",
        fichesData: []
      }
    }
  }
</script>

<style>
.list-filtre li.active {
  background: #086fab;
}
</style>
